import React, { PropsWithChildren } from 'react';
import {
  SnackbarProvider as SnackbarProviderV3,
  ThemeProvider as PounceV2ThemeProvider,
} from 'pounceV2';
import { SidesheetProviderV3 } from 'Components/utils/Sidesheet/SidesheetContextV3';
import SidesheetManagerV3 from 'Components/utils/Sidesheet/SidesheetManagerV3';
import { ModalProviderV3 } from 'Components/utils/Modal/ModalContextV3';
import { ModalManagerV3 } from 'Components/utils/Modal/ModalManagerV3';
import { MermaidProviderV3 } from 'Components/utils/Mermaid';
import { BreadcrumbProvider } from 'Source/contexts/breadcrumbContext/Context';
import { PageHeaderProviderV3 } from 'Source/contexts/pageHeaderContext';
import { WasmProvider } from 'Components/utils/Wasm/WasmContext';
import { AIPanelProviderV3 } from 'Components/AIPanelV3';
import {
  ThemeProvider as PantherThemeProvider,
  useThemeContext,
} from 'Source/contexts/themeContext';

// Reads effectiveTheme from PantherThemeProvider and passes it to pounceV2's MUI ThemeProvider.
// Must be a child of PantherThemeProvider since it calls useThemeContext().
const PounceV2ThemeBridge: React.FC<PropsWithChildren> = ({ children }) => {
  const { effectiveTheme } = useThemeContext();
  return <PounceV2ThemeProvider mode={effectiveTheme}>{children}</PounceV2ThemeProvider>;
};

const UIProviders: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <PantherThemeProvider>
      <PounceV2ThemeBridge>
        <ModalProviderV3>
          <SidesheetProviderV3>
            <AIPanelProviderV3>
              <WasmProvider>
                <MermaidProviderV3>
                  <SnackbarProviderV3>
                    <BreadcrumbProvider>
                      <PageHeaderProviderV3>{children}</PageHeaderProviderV3>
                    </BreadcrumbProvider>
                    <ModalManagerV3 />
                    <SidesheetManagerV3 />
                  </SnackbarProviderV3>
                </MermaidProviderV3>
              </WasmProvider>
            </AIPanelProviderV3>
          </SidesheetProviderV3>
        </ModalProviderV3>
      </PounceV2ThemeBridge>
    </PantherThemeProvider>
  );
};

export default UIProviders;
